/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-12-08 10:47:46
 * @LastEditors: changfeng
 * @LastEditTime: 2023-02-22 13:49:00
 */
export default {
  'advertise.account': 'Ad Account',
  'advertise.select.template': '选择模板',
  'advertise.promotion.series': '推广系列',
  'advertise.putin.time': '广告组开始投放时间',
  'advertise.video.material': '视频素材',
  'advertise.create.material': '新建一条素材',
};
